export default {"src":"/_next/static/media/bwcon.fbe94c44.svg","height":48,"width":122,"blurWidth":0,"blurHeight":0};